import { BaseCancelRequest } from 'Forms/CancelFormV2/cancelForm.types';

export interface CancelElectricScooterFormValues {
  cancelReason?: CancelReasonElectricScooter;
}

export type CancelElectricScooterRequest = BaseCancelRequest;

export enum CancelReasonElectricScooter {
  SOLD = '1',
  BROKEN_AND_RECYCLED = '2',
}
